import React from 'react';
import { motion } from 'framer-motion'; // Import Framer Motion
import '../styles/contact.css';
import ContactImage from '../assets/contact-image.png';
import EmailIcon from '../assets/email-icon.svg';
import TelIcon from '../assets/tel-icon.svg';
import AddressIcon from '../assets/address-icon (2).svg';
import Call from '../components/Call';
import Footer from '../components/Footer';
import '../styles/quote.css';

function Contact() {
    return (
        <motion.div 
            className="contact-container"
            initial={{ opacity: 0 }} 
            animate={{ opacity: 1 }} 
            transition={{ duration: 0.8 }}
        >
            {/* Contact Header */}
            <motion.div 
                className="contact-container-text"
                initial={{ y: -50, opacity: 0 }} // Slide in from top
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.8, ease: 'easeOut' }}
            >
                <h2>Contact Us</h2>
            </motion.div>
        
            {/* Contact Content */}
            <div className="contact-content">
                {/* Contact Image */}
                <motion.div 
                    className="contact-content-image"
                    initial={{ opacity: 0, x: -50 }} // Slide in from left
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                >
                    <img src={ContactImage} alt="nextcastle-contact-image" />
                </motion.div>

                {/* Contact Text Section */}
                <motion.div 
                    className="contact-content-text"
                    initial={{ opacity: 0, x: 50 }} // Slide in from right
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                >
                    <h2>Get in Touch</h2>
                    <p>We are here to answer your questions, discuss your projects, and explore opportunities to work together. Contact us today, and let’s build a future powered by excellence.</p>
                    
                    {/* Contact Information */}
                    <div className="contact-information">
                        <motion.div 
                            className="email-address"
                            whileHover={{ scale: 1.05 }} // Slight hover effect
                        >
                            <img src={EmailIcon} alt="email-icon" />
                            <a href="mailto:info@nextcastlegroup.com?subject=Inquiry&body=Hello, I would like to know more about...">
                                info@nextcastlegroup.com
                            </a>
                        </motion.div>

                        <motion.div 
                            className="telephone"
                            whileHover={{ scale: 1.05 }}
                        >
                            <img src={TelIcon} alt="tel-icon" />
                            <a href="tel:+2348022862128">+234 802 286 2128</a>
                        </motion.div>

                        <motion.div 
                            className="address"
                            whileHover={{ scale: 1.05 }}
                        >
                            <img src={AddressIcon} alt="address" />
                            <p>Plot 477 Trans Amadi Industrial Layout, Port Harcourt</p>
                        </motion.div>
                    </div>
                </motion.div>
            </div>

            {/* Google Maps Section */}
            <motion.div 
                className="map-container"
                initial={{ opacity: 0, y: 50 }} // Slide in from bottom
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.6 }}
            >
                <iframe 
                    className='map'
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3975.7504602333947!2d7.041739573106209!3d4.812855040678974!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1069cc5380fc4293%3A0x6d02c781f3763e12!2s477%20Trans-Amadi%20Industrial%20Layout%20Rd%2C%20PHALGA%2C%20Port%20Harcourt%20500102%2C%20Rivers!5e0!3m2!1sen!2sng!4v1742570266880!5m2!1sen!2sng"
                    width="100%"
                    height="500"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Google Maps"
                ></iframe>
            </motion.div>

            <Call />
            <Footer />
        </motion.div>
    );
}

export default Contact;
